<template>
  <nav>
    <i @click="open = !open">
      <IconBurgerMenu size="24"/>
    </i>

    <template v-if="open">
      <div @click="open = false"/>
      <ul>
        <a 
          v-for="item in items" 
          :key="item.id" 
          :href="item.to || item.href"
          v-text="item.title"
          @click.prevent="onClick(item)"
        />
      </ul>
    </template>
  </nav>
</template>


<script>
import IconBurgerMenu from '@icons/IconBurgerMenu';
import { mapMutations } from 'vuex';

export default {
  name: 'GameMenu',

  components: {
    IconBurgerMenu,
  },

  emits: ['close', 'reload-lobby', 'logout'],

  data: ths => ({
    open: false,
    items: [
      { id: 'home',           title: 'Главная',         to: '/' },
      { id: 'play',           title: 'Игра',            to: '/play' },
      { id: 'news',           title: 'Новости',         to: '/news' },
      { id: 'ratings',        title: 'Победители',      to: '/ratings' },
      { id: 'docs',           title: 'Документация',    to: '/docs' },
      { id: 'starmiix',       title: 'Другие игры',     href: '/api/auth/lobby' },
      { id: 'logout',         title: 'Выход',           href: '/logout' },
    ],
  }),

  methods: {
    ...mapMutations([
      'setRedirectLoading',
    ]),
    onClick(item) {
      this.open = false;
      if (item.href) {
        this.setRedirectLoading(true);
        window.location = item.href;
      } else if (item.to) this.$router.push(item.to);
    },
  },
};
</script>


<style lang="scss" scoped>
nav {
  display: flex;
  justify-content: flex-end;
  position: relative;
  color: var(--color-primary);
  height: inherit;
  z-index: 110;

  & > i {
    height: inherit;
    display: flex;
    align-items: center;
    translate: 4px;
    padding: 0 8px;
    border-radius: 8px;
    z-index: 1;
    background-color: #E7DFCC;

    &:has(+ div) {
      background-color: var(--color-white);
    }

    svg {
      z-index: 1;
      @media (hover: hover) {
        cursor: pointer;
        transition: transform .1s, opacity .1s;
        &:hover {
          transform: scale(.95);
          opacity: .9;
        }
      }
    }
  }

  & > div {
    position: fixed;
    background-color: #0004;
    backdrop-filter: blur(3px);
    cursor: pointer;
    inset: 0;
  }

  ul {
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 20px;
    border-radius: 8px;
    padding: 16px 0;
    background-color: var(--color-white);
    position: absolute;
    top: calc(100% + 4px);
    right: -4px;
    margin: 0;
    display: flex;
    flex-direction: column;

    a {
      font-size: 18px;
      display: grid;
      align-items: center;
      color: inherit;
      text-decoration: none;
      white-space: nowrap;
      padding: 12px 28px;
      font-weight: bold;
      line-height: 1.15;
      cursor: pointer;
      gap: 4px;

      @media (hover: hover) {
        &:hover {
          background-color: #0001;
        }
      }
    }
  }
}
</style>